import React from 'react';
import { useBookingList } from '../../../contextsProperty/ContextBookings';
import TextInput from '../../../../muiComponents/TextInput/TextInput';
import LoadedOptionsTypeahead from '../../../../muiComponents/LoadedOptionsTypeahead';
import OdataTypeahead from './OdataTypeahead';
import Grid from '../../../../muiComponents/Grid';
import GridChild from '../../../../muiComponents/GridChild';
import { readOnlyEntities } from '../../../../utils/commonVariables/entityKeys';
import { filterColumnGrid, filterDateColumnGrid } from '../yourBookingsHelpers';
import '../../../../stylesheets/stylesLayout/listFilters.scss';
import FiltersBar from '../../../../Table/FiltersBar';
import {
    BookingListViewType,
    BookingStatusKey,
} from '../../../../types/booking/bookingListTypes';
import DateInput from '../../../../muiComponents/DateInput';
import { useIdHotelOwner } from '../../../../contexts/HotelOwnerContext';
import { useODataMultipleQueries } from '../../../../customHooks/useODataMultipleQueries';
import ChangeViewButtonBar from '../../../../Table/ChangeViewButtonBar';
import { commonIcons } from '../../../../utils/commonVariables/commonIcons';
import {
    gridSpacing10,
    gridSpacing15,
} from '../../../../utils/commonVariables/grid';

const BookingsFiltersBar = () => {
    const {
        filters,
        handleFilterChange,
        handleClearFilters,
        handleSearch,
        totalResults,
        currentResults,
        isLoading,
        handleChangeVisibleView,
        visibleView,
    } = useBookingList();
    const IdHotelOwner = useIdHotelOwner();

    const bookingStatusEndpoint = [
        {
            key: 'statuses',
            endpoint: {
                entityName: readOnlyEntities.SupplierBookingStatusType,
                select: 'Id,Caption,LocalizedCaption,Name',
                filter: [
                    {
                        or: [
                            { Key: { eq: BookingStatusKey.COMMITTED } },
                            { Key: { eq: BookingStatusKey.CANCELLED } },
                        ],
                    },
                ],
            },
        },
    ];
    const { statuses } = useODataMultipleQueries({
        queries: bookingStatusEndpoint,
        dependencies: [],
    });

    const buttonsButtonBar = [
        {
            icon:
                visibleView === BookingListViewType.CALENDAR
                    ? commonIcons.LIST
                    : commonIcons.CALENDAR,
            label:
                visibleView === BookingListViewType.CALENDAR
                    ? 'list'
                    : 'calendar',
            view:
                visibleView === BookingListViewType.CALENDAR
                    ? BookingListViewType.TABLE
                    : BookingListViewType.CALENDAR,
        },
        {
            icon: 'InsertChartOutlined',
            label: 'statistics',
            view: BookingListViewType.STATISTICS,
        },
    ];

    return (
        <FiltersBar
            title='bookings'
            clearFilters={handleClearFilters}
            search={async () => await handleSearch(1)}
            isLoading={isLoading}
            currentResults={currentResults}
            totalResults={totalResults}
            endButtonBar={
                <ChangeViewButtonBar
                    changeVisibleView={handleChangeVisibleView}
                    buttons={buttonsButtonBar}
                />
            }
        >
            <Grid
                columnSpacing={gridSpacing10}
                rowSpacing={gridSpacing15}
                style={{ width: '100%' }}
            >
                <GridChild gridProps={filterColumnGrid}>
                    <LoadedOptionsTypeahead
                        labelText={'status'}
                        optionsLabelKey={'LocalizedCaption'}
                        options={statuses.data || []}
                        value={filters.IdStatus.value || null}
                        handleChange={(e, newValue) =>
                            handleFilterChange('IdStatus', newValue)
                        }
                    />
                </GridChild>
                <GridChild gridProps={filterColumnGrid}>
                    <TextInput
                        labelText={'booking_code'}
                        id={'bookingCode'}
                        value={filters.BookingCode.value || ''}
                        handleChange={(e, newValue) =>
                            handleFilterChange('BookingCode', newValue)
                        }
                        onKeyPress={async e => {
                            if (e.key === 'Enter') {
                                await handleSearch(1);
                            }
                        }}
                    />
                </GridChild>
                <GridChild gridProps={filterColumnGrid}>
                    <OdataTypeahead
                        labelText={'hotel'}
                        optionsLabelKey={'Name'}
                        endpoint={`${readOnlyEntities.SupplierHotel}?$select=Id,Name&$top=50`}
                        odataAdditionalFilter={{
                            key: 'IdHotelOwner',
                            operator: 'eq',
                            value: IdHotelOwner,
                        }}
                        handleChange={opt => {
                            handleFilterChange('IdSupplierHotel', opt);
                        }}
                        idValue={filters.IdSupplierHotel.value || null}
                    />
                </GridChild>
                <GridChild gridProps={filterDateColumnGrid}>
                    <DateInput
                        value={filters.BookingDateFrom.value}
                        labelText={'booking_date_from'}
                        onChange={newDate => {
                            handleFilterChange('BookingDateFrom', newDate);
                        }}
                    />
                </GridChild>
                <GridChild gridProps={filterDateColumnGrid}>
                    <DateInput
                        value={filters.BookingDateTo.value}
                        labelText={'to'}
                        onChange={newDate => {
                            handleFilterChange('BookingDateTo', newDate);
                        }}
                    />
                </GridChild>
                <GridChild gridProps={filterDateColumnGrid}>
                    <DateInput
                        value={filters.CheckInDateFrom.value}
                        labelText={'check_in_from'}
                        onChange={newDate => {
                            handleFilterChange('CheckInDateFrom', newDate);
                        }}
                    />
                </GridChild>
                <GridChild gridProps={filterDateColumnGrid}>
                    <DateInput
                        value={filters.CheckInDateTo.value}
                        labelText={'to'}
                        onChange={newDate => {
                            handleFilterChange('CheckInDateTo', newDate);
                        }}
                    />
                </GridChild>
                <GridChild gridProps={filterDateColumnGrid}>
                    <DateInput
                        value={filters.CheckOutDateFrom.value}
                        labelText={'check_out_from'}
                        onChange={newDate => {
                            handleFilterChange('CheckOutDateFrom', newDate);
                        }}
                    />
                </GridChild>
                <GridChild gridProps={filterDateColumnGrid}>
                    <DateInput
                        value={filters.CheckOutDateTo.value}
                        labelText={'to'}
                        onChange={newDate => {
                            handleFilterChange('CheckOutDateTo', newDate);
                        }}
                    />
                </GridChild>
            </Grid>
        </FiltersBar>
    );
};

export default BookingsFiltersBar;
